module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (_vm.loading) ? _vm._c('li', [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42088116", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42088116!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Option.vue
// module id = 173
// module chunks = 0